import * as React from 'react';
import {connect} from 'react-redux';
import {getUserDetails} from '../../services/userService';
import {Async} from '../reusableComponents/Async';
import {Loader} from '../reusableComponents/Loader/Loader';
import {ErrorPage} from '../reusableComponents/ErrorPage';
import {BasePage} from '../reusableComponents/BasePage';
import {UserModel} from '../../model/UserModel';
import {Icon} from '../reusableComponents/Icon';
import {withRouter} from 'react-router';
import {IHistory} from '../../interfaces';
import {DeleteUserDialog} from './DeleteUserDialog';
import {getCurrentUserUUID} from '../../utils/generalUtils';
import {getUserData} from '../../services/utilityServices';

export interface IUserDetailsPageProps {
    id: string;
    instance: UserModel;
    history: IHistory;
    userSignBase64: string;
    userImageBase64: string;
}

export interface IUserDetailsPageState {
    open: boolean;
    isUserActive: boolean;
    oldUserStatus: boolean;
}

export class UserDetailsPageImpl extends React.PureComponent<IUserDetailsPageProps, IUserDetailsPageState> {
    constructor(props: IUserDetailsPageProps) {
        super(props);
        this.state = {
            open: false,
            isUserActive: props && props.instance && props.instance.props.Active,
            oldUserStatus: props && props.instance && this.props.instance.props.Active
        };
    }

    public promise = async () => {
        if (this.props.id !== getCurrentUserUUID()) {
            await getUserDetails(this.props.id);
        }
    }

    userActiveSwitchChange = (status, isWindowToOpen?: boolean) => {
        this.setState({
            isUserActive: status
        }, () => {
            this.setState({
                open: isWindowToOpen
            });
        });
    }

    public renderDetails = () => {

        if (!this.props.instance) {
            return <Loader type="async"/>;
        }
        const {
            FirstName, Email, AccessLevel, JobTitle, OrganizationName,
            MiddleName, LastName, PhoneNumber, JobDescription, Active
        } = this.props.instance.props;
        const isSameLevel = getUserData().accessLevel === AccessLevel;
        const isAdmin = getCurrentUserUUID() === (this.props.instance ? this.props.instance.props.id : '');
        return <div className="details-page">
            <div className="container">
                <DetailsRow label="Name:" value={`${FirstName} ${MiddleName} ${LastName}`}/>
                <DetailsRow label="Email:" value={Email}/>
                <DetailsRow label="Access Level:" value={AccessLevel}/>
                <DetailsRow label="Organization:" value={OrganizationName}/>
                <DetailsRow label="Phone Number:" value={PhoneNumber}/>
                <DetailsRow label="Job Title:" value={JobTitle}/>
                <DetailsRow label="Job Description:" value={JobDescription}/>
            </div>
            {!isSameLevel && <div className="options-container">
                {isAdmin ? '' :
                    <div className="delete" onClick={() => this.userActiveSwitchChange(!Active, true)}>
                        <Icon icon="trash"/>
                        &nbsp;
                        {Active ? 'Deactivate' : 'Activate'}
                    </div>}
                <div className="add-new"
                     onClick={() => this.props.history.push(`/users/edit/${this.props.instance.props.id}`)}>
                    <Icon icon="pencil-alt"/>
                    &nbsp;
                    Edit
                </div>
            </div>}
        </div>;
    }

    public getUserImage = () => {
        if (this.props.id === getCurrentUserUUID()) {
            return this.props.userImageBase64;
        }
        return this.props.instance && this.props.instance.props.UserImage;
    }

    public render() {
        return <BasePage
            pic={this.getUserImage()}
            title={this.props.instance ?
                `${(this.props.instance && this.props.instance.props.FirstName) + `'s`} Details`
                : 'User Details'}>
            <DeleteUserDialog
                history={this.props.history}
                onClose={() => this.userActiveSwitchChange(this.state.oldUserStatus, false)}
                open={this.state.open}
                userStatus={this.state.isUserActive}
                instance={this.props.instance}/>
            <Async
                identifier="User Details Page"
                promise={this.promise}
                loader={<Loader type="async"/>}
                content={this.renderDetails()}
                error={<ErrorPage/>}
            />
            <div className="options-container">
                {/* <div className="delete" >
                    <Icon icon="trash" />
                    &nbsp;
                    Delete
                </div> */}
            </div>
        </BasePage>;
    }
}

export function mapStateToProps(state, ownProps) {
    return {
        id: ownProps.match.params.id,
        instance: UserModel.get(ownProps.match.params.id),
        userImageBase64: state.miscellaneous.get('userImageBase64'),
        userSignBase64: state.miscellaneous.get('userSignBase64')
    };
}

export const UserDetailsPage =
    withRouter(connect<{}, {}, IUserDetailsPageProps>(mapStateToProps)(UserDetailsPageImpl) as any);

const DetailsRow = ({label, value}) => {
    return <div className="details">
        <div className="label">{label}</div>
        <div className="value">{value || 'NA'}</div>
    </div>;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Users/UserDetailsPage.tsx